import { EMPTY_ARRAY } from '@applyonline/shared'
import {
  SchemaConstants as BaseSchemaConstants,
  EMAIL_IFINANCE,
  PHONE_NUMBER_IFINANCE,
  PHONE_NUMBER_LINK_IFINANCE,
  Constants as SharedConstant
} from '@applyonline/shared/types'
import { EProvince } from '@if/core/types'

/** Many configurations for B2c need to be dynamically determined due to merchant
 * specific configs. Some also just don't matter to B2c.
 */
type B2cBaseSchemaConstants = Omit<
  BaseSchemaConstants,
  | 'BaseMinTerm'
  | 'BaseMaxTerm'
  | 'CorrectedMaxTerm'
  | 'MinLoanAmount'
  | 'MaxLoanAmount'
  | 'LongTerm'
  | 'LargeLoanAmount'
>

export interface B2CSchemaConstants extends B2cBaseSchemaConstants {
  Host: {
    Ifinance: string
    [key: string]: string | undefined
  }
}

export const COVERED_PROVINCE_CIRCLEK = new Set<EProvince>([EProvince.Ontario])
export const MINIMUM_ANNUAL_INCOME = 21000

export const B2C_MERCHANT_IDS = {
  circlek: 'alis*23491',
  qualify: 'alis*24731',
  neo: 'alis*24731',
}

export const Constants: B2CSchemaConstants & typeof SharedConstant = {
  ...SharedConstant,
  IncludeCoapplicant: false,
  FinanceFeeRateForRegular: 0.06,
  MinIncomes: 21000,
  MaxRate: 31.99,
  Host: {
    Ifinance: 'https://ifinancecanada.com',
  },
  MaxIncomes: 1000000,
}

export const CIRCLEK_CAMPAIN_ID = '1'
export const CIRCLEK_BRAND_ID = '1'
export const MARCS_BRAND_ID = '3'
export { EJobTypeWithUnemployed, EReviewLink, ESessionStorageKeys } from '@applyonline/shared/types'
export { EMAIL_IFINANCE, EMPTY_ARRAY, PHONE_NUMBER_IFINANCE, PHONE_NUMBER_LINK_IFINANCE, SharedConstant }
